export default () => ({
    first_name       : '',
    last_name        : '',
    address_primary  : '',
    address_secondary: '',
    city             : '',

    is_international_customer: false,
    //us customer
    state                    : '',
    zip                      : '',
    // international customer
    province                 : '',
    postal_code              : '',
    country                  : '',

    phone               : '',
    email               : '',
    email_confirmation  : '',
    local_accommodations: '',

    //reservation
    date_pickup     : null,
    date_return     : null,
    pickup_day      : 'day_of',
    pickup_hour     : '',
    reservees_number: 1,
    is_seasonal     : 0,
    is_delivery     : 0,
    is_prepay     : 0,
    additional_info : '',
    coupon_id : '',
    prepay_total_packages_price : 0,

    _type: 'advance',
    _meta: {},
    is_from_vue: 1,
    gender_is_on: 1,
    single_day_type: '',
    return_day_after: 'no',
    pickup_day_time: '',
    special_fee_total: 0,

    delivery_in_shop: false,
    referral_id: '',
    group_link_id: 0,
    location: '',
});
